import React, { useRef, useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const SummaryVolume = props => {
    const StyledTableRow = withStyles((theme) => ({
        root: {},
    }))(TableRow);
    return (
        <>
            <Table className='summary-details-tb'>
                <TableHead>
                    <TableRow>
                        <TableCell width={116}></TableCell>
                        <TableCell width={279}>AM Peak Hour</TableCell>
                        <TableCell width={279}>AM Peak Hour Volume</TableCell>
                        <TableCell width={279}>PM Peak Hour</TableCell>
                        <TableCell width={279}>PM Peak Hour Volume</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <StyledTableRow>
                        <TableCell>Combined</TableCell>
                        <TableCell>{props.getCombinedData[0] && props.getCombinedData.length != 0 ? (props.getCombinedData[0]['amPeakHour'] ? props.getCombinedData[0]['amPeakHour'] : '--') : '--'}</TableCell>
                        <TableCell>{props.getCombinedData[0] && props.getCombinedData.length != 0 ? (typeof(props.getCombinedData[0]['amPeakVolume']) === "number" ? props.getCombinedData[0]['amPeakVolume'] : '--') : '--'}</TableCell>
                        <TableCell>{props.getCombinedData[1] && props.getCombinedData.length != 0 ? (props.getCombinedData[1]['pmPeakHour'] ? props.getCombinedData[1]['pmPeakHour'] : '--') : '--'}</TableCell>
                        <TableCell>{props.getCombinedData[1] && props.getCombinedData.length != 0 ? (typeof(props.getCombinedData[1]['pmPeakVolume'])  === "number"? props.getCombinedData[1]['pmPeakVolume'] : '--') : '--'}</TableCell>
                    </StyledTableRow>
                    {props.getDirectionName && <StyledTableRow>
                        <TableCell>{props.getDirectionName}</TableCell>
                        <TableCell>{props.getNBData[0] && props.getNBData.length != 0 ? (props.getNBData[0]['amPeakHour'] ? props.getNBData[0]['amPeakHour'] : '--') : '--'}</TableCell>
                        <TableCell>{props.getNBData[0] && props.getNBData.length != 0 ? (typeof(props.getNBData[0]['amPeakVolume']) === "number" ? props.getNBData[0]['amPeakVolume'] : '--') : '--'}</TableCell>
                        <TableCell>{props.getNBData[1] && props.getNBData.length != 0 ? (props.getNBData[1]['pmPeakHour'] ? props.getNBData[1]['pmPeakHour'] : '--') : '--'}</TableCell>
                        <TableCell>{props.getNBData[1] && props.getNBData.length != 0 ? (typeof(props.getNBData[1]['pmPeakVolume']) === "number" ? props.getNBData[1]['pmPeakVolume'] : '--') : '--'}</TableCell>
                    </StyledTableRow>}
                    {props.getDirectionNameTab && <StyledTableRow>
                        <TableCell>{props.getDirectionNameTab}</TableCell>
                        <TableCell>{props.getSBData[0] && props.getSBData.length != 0 ? (props.getSBData[0]['amPeakHour'] ? props.getSBData[0]['amPeakHour'] : '--') : '--'}</TableCell>
                        <TableCell>{props.getSBData[0] && props.getSBData.length != 0 ? (typeof(props.getSBData[0]['amPeakVolume']) === "number"  ? props.getSBData[0]['amPeakVolume'] : '--') : '--'}</TableCell>
                        <TableCell>{props.getSBData[1] && props.getSBData.length != 0 ? (props.getSBData[1]['pmPeakHour'] ? props.getSBData[1]['pmPeakHour'] : '--') : '--'}</TableCell>
                        <TableCell>{props.getSBData[1] && props.getSBData.length != 0 ? (typeof(props.getSBData[1]['pmPeakVolume']) === "number" ? props.getSBData[1]['pmPeakVolume'] : '--') : '--'}</TableCell>
                    </StyledTableRow>}
                </TableBody>
            </Table>
        </>
    )
}

export default SummaryVolume;